import React from "react";
import classNames from "classnames";
import { isMobileBrowser } from "../commons/HelperFunctions";
import TrustPilotWidget from "./TrustPilot/TrustPilotWidget";
import { GDLogo } from "./GDLogo";
import classes from "./TopBanner.module.scss";

const GD_LOGO_WIDTH = 150;

type TopBannerProps = {
  color: string;
};

function TopBanner({ color }: TopBannerProps) {
  const isMobile = isMobileBrowser();

  return (
    <div id="topBanner" className={ classNames(classes.topBanner) }>
      <GDLogo width={ GD_LOGO_WIDTH } color={ color } isMobile={ isMobile } />
      <TrustPilotWidget isMobile={ isMobile } />
    </div>
  );
}

export default TopBanner;
